export default __webpack_public_path__ + "static/media/search__help.b7104def.png";